<template>
  <div class="admin-layout">
    <aside class="admin-sidebar">
      <div class="sidebar-header">
        <router-link to="/" class="logo-link">天狗商城</router-link>
        <span class="sub-title">后台管理</span>
      </div>
      <nav class="sidebar-nav">
        <router-link to="/admin/users" class="nav-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
          <span>用户管理</span>
        </router-link>
        <router-link to="/admin/products" class="nav-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>
          <span>商品管理</span>
        </router-link>
         <router-link to="/admin/orders" class="nav-item">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg>
    <span>订单管理</span>
  </router-link>
        <div class="nav-divider"></div>
        <router-link to="/" class="nav-item back-home">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
          <span>返回商城首页</span>
        </router-link>
      </nav>
    </aside>
    <main class="admin-main-content">
      <div class="content-wrapper">
        <router-view />
      </div>
    </main>
  </div>
</template>

<style scoped>
.admin-layout {
  display: flex;
  min-height: 100vh;
  background-color: #f4f7f6;
}
.admin-sidebar {
  width: 240px;
  background-color: #fff;
  border-right: 1px solid #e9ecef;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.sidebar-header {
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid #e9ecef;
}
.logo-link {
  font-size: 1.5em;
  font-weight: 700;
  color: #5e72e4;
  text-decoration: none;
}
.sub-title {
  display: block;
  font-size: 0.8em;
  color: #888;
  margin-top: 5px;
}
.sidebar-nav {
  padding: 15px;
  flex-grow: 1;
}
.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 15px;
  border-radius: 8px;
  text-decoration: none;
  color: #555;
  font-weight: 500;
  margin-bottom: 5px;
  transition: all 0.3s;
  /* [修改] 为未选中项添加一个非常浅的背景色 */
  background-color: #f8f9fa;
}
.nav-item:hover {
  /* [修改] 稍微加深 hover 效果的背景色 */
  background-color: #f1f3f5;
  color: #333;
}
.nav-item.router-link-exact-active {
  background-color: #5e72e4;
  color: #fff;
  box-shadow: 0 4px 10px rgba(94, 114, 228, 0.3);
}
/* [修改] 当激活时，覆盖 hover 效果，防止背景色变化 */
.nav-item.router-link-exact-active:hover {
    background-color: #5e72e4;
    color: #fff;
}
.nav-item.disabled {
  color: #aaa;
  cursor: not-allowed;
  pointer-events: none;
  background-color: transparent;
}
.nav-divider {
  height: 1px;
  background-color: #e9ecef;
  margin: 15px 0;
}
.back-home {
  margin-top: auto;
}
.admin-main-content {
  flex-grow: 1;
  padding: 30px;
  overflow-y: auto;
}
.content-wrapper {
  max-width: 1200px;
  margin: 0 auto;
}
</style>